// SPDX-License-Identifier: BUSL-1.1
/**
 * Heartbeat invocation-source vocabulary (HB-07, NocoDB #4408).
 *
 * Single source of truth for the `source` enum used by:
 *   - ops_agent_heartbeat_events.source CHECK constraint (HB-01 migration 0019)
 *   - POST /api/agents/:agentId/heartbeat route validation
 *   - @cli-ceo/api-client `heartbeat()` typed param
 *   - @cli-ceo/mcp-server `agents_heartbeat` tool input schema
 *   - UI badge + history table source column
 *
 * Vocabulary derived from Paperclip's `invocation_source` pattern. Each
 * SDK adapter (Paperclip, Claude MA, custom) maps its native trigger to
 * one of these values when calling the heartbeat endpoint. See
 * docs/CLI_AGENTS_INTEGRATION.md for the per-platform mapping table.
 */
export const HEARTBEAT_INVOCATION_SOURCES = [
    /** Scheduled tick / interval. */
    'timer',
    /** An issue / task was assigned to the agent. */
    'assignment',
    /** Explicit user or API request (manual wakeup). */
    'on_demand',
    /** Continuation, retry, recovery, or watchdog-triggered. */
    'automation',
    /** Legacy or unmapped — present for backwards compatibility. */
    'unknown',
];
/** Type guard — narrows `unknown` to a valid source. */
export function isHeartbeatInvocationSource(v) {
    return (typeof v === 'string' &&
        HEARTBEAT_INVOCATION_SOURCES.includes(v));
}
/**
 * Human-readable label for UI rendering. Keep in sync with the badge
 * component (packages/ui/src/components/heartbeat-source-badge.tsx).
 */
export const HEARTBEAT_INVOCATION_SOURCE_LABELS = {
    timer: 'Timer',
    assignment: 'Assignment',
    on_demand: 'On demand',
    automation: 'Automation',
    unknown: 'Unknown',
};
//# sourceMappingURL=heartbeat-sources.js.map